function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { CACHE_PERSIST_PREFIX } from '@magento/peregrine/lib/Apollo/constants';

/**
 * Deletes specific entry/entries from the apollo cache and then tries to
 * persist the deletions.
 *
 * @param {ApolloClient} client apollo client instance
 * @param {Function} predicate a matching function
 */
export var deleteCacheEntry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (client, predicate) {
    yield deleteActiveCacheEntry(client, predicate);
    yield deleteInactiveCachesEntry(client, predicate);
  });
  return function deleteCacheEntry(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var deleteActiveCacheEntry = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (client, predicate) {
    // If there is no client or cache then just back out since it doesn't matter :D
    if (!client || !client.cache || !client.cache.data || !client.cache.data.data) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('Apollo Cache entry deletion attempted without client or cache.');
      }
      return;
    }

    // Remove from the active cache.
    Object.keys(client.cache.data.data).forEach(key => {
      if (predicate(key)) {
        client.cache.data.delete(key);
      }
    });

    // Immediately persist the cache changes to the active cache storage.
    if (client.persistor) {
      yield client.persistor.persist();
    }
  });
  return function deleteActiveCacheEntry(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var deleteInactiveCachesEntry = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (client, predicate) {
    if (!client || !client.persistor) return;
    var activeApolloCacheLocalStorageKey = client.persistor.persistor.storage.key;
    var isAnInactiveApolloCache = _ref4 => {
      var [key] = _ref4;
      return key.startsWith(CACHE_PERSIST_PREFIX) && key !== activeApolloCacheLocalStorageKey;
    };
    Object.entries(localStorage).filter(isAnInactiveApolloCache).forEach(_ref5 => {
      var [inactiveCacheKey, inactiveCacheValue] = _ref5;
      var inactiveApolloCache = JSON.parse(inactiveCacheValue);
      Object.keys(inactiveApolloCache).forEach(key => {
        if (predicate(key)) {
          delete inactiveApolloCache[key];
        }
      });

      // We're done deleting keys that match the predicate,
      // but we've only mutated the object in memory.
      // Write the updated inactive cache back out to localStorage.
      localStorage.setItem(inactiveCacheKey, JSON.stringify(inactiveApolloCache));
    });
  });
  return function deleteInactiveCachesEntry(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();